const GroupCardType = {
  Default: 'DEFAULT',
  Preview: 'PREVIEW',
  Full: 'FULL',
}

export default GroupCardType
